module.exports = __webpack_public_path__ + "media/lobby_normal2.0100ba15.mp3";